import { Box, Button as MuiButton } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const ActionButton = styled(MuiButton)(({ theme }) => ({
  textTransform: "none",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.75, 1.5),
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1,
  color: theme.palette.text.secondary,

  "& .MuiSvgIcon-root": {
    fontSize: 14,
  },

  "&:hover, &:focus, &:active, &.Mui-focusVisible": {
    color: theme.palette.gold.dark,
    borderColor: theme.palette.gold.dark,
    backgroundColor: alpha(theme.palette.gold.main, 0.16),
  },
}));
